import $ from 'jquery';
const DEFINE_MIDDLE_NAME_SPACE = 'brunchColl';

export const DEFINE_MIDDLE = C[DEFINE_MIDDLE_NAME_SPACE]['data'];
export const EXPAND = {
  END_OF_PAGE   : 6,
  START_OF_PAGE : 2,
  FLAG_IS_END   : 'end_of_list',
  LOG_EXPAND    : $.param({
    s  : 'TO',
    a  : DEFINE_MIDDLE.LOG_CODE,
    dc : DEFINE_MIDDLE.DA,
    at : 'func',
    e  : 2
  }),
  LOG_FOLD      : $.param({
    s  : 'TO',
    a  : DEFINE_MIDDLE.LOG_CODE,
    dc : DEFINE_MIDDLE.DA,
    at : 'func',
    e  : 3
  }),
  MORE_EXPAND    : $.param({
    s  : 'TO',
    a  : DEFINE_MIDDLE.LOG_CODE,
    dc : DEFINE_MIDDLE.DA,
    at : 'func',
    e  : 4
  }),
  MORE_FOLD      : $.param({
    s  : 'TO',
    a  : DEFINE_MIDDLE.LOG_CODE,
    dc : DEFINE_MIDDLE.DA,
    at : 'func',
    e  : 5
  })
};


/** WEBPACK FOOTER **
 ** ./src/brunch/define.js
 **/